const ProductionStatisticsData = (props) => {
  const { data } = props;
  const uniqueRows = [];

  const dataRows = data?.map((row) => {
    const effectiveDate = new Date(row.effectivedate);
    const formattedDate = effectiveDate.toLocaleDateString();
    return {
      id: row.tadstatsProductionId,
      agentName: row.agentName,
      npn: row.npn,
      carrierName: row.carrierName,
      companyName: row.companyName,
      hlevel: row.hlevel,
      ma: row.ma,
      medsupp: row.medsupp,
      pdp: row.pdp,
      salesYear: row.salesYear,
      county: row.county,
      state: row.state,
      effectivedate: formattedDate,
      uplines: row.uplines,
    };
  });

  dataRows.forEach((row) => {
    uniqueRows.push(row);
  });

  return uniqueRows;
};

export default ProductionStatisticsData;
